/**
 * 店铺设置上下文
 * 提供全局的店铺信息（名称、Logo 等）
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { productApi } from '../api/index';

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 加载店铺设置
    productApi.getSettings()
      .then(data => {
        setSettings(data || {});
      })
      .catch(err => {
        console.error('加载店铺设置失败:', err);
        setSettings({
          storeName: '悦来悦好',
          logoUrl: '',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const value = {
    settings,
    loading,
    storeName: settings?.storeName || '悦来悦好',
    logoUrl: settings?.logoUrl || '',
  };

  return (
    <StoreContext.Provider value={value}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
}
